export default __webpack_public_path__ + "static/media/directory-icon.5d8f9e67.svg";